import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Layout, Button } from "antd";
import { IoMdPin } from "react-icons/io";
import { FaArrowRight, FaClock, FaEnvelope } from "react-icons/fa";
import { BsFillTelephoneFill } from "react-icons/bs";
import { ImageUrl } from "../../helpers/Functions";
import "../course-management/course-management.css";
import "./contact-us.css";

function ContactUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Childcare Health & Environmental Consulting in Bronx NY</title>
        <meta
          name="description"
          content="Contact WrightCo Academy for childcare facility health assessments and expert environmental health consulting services designed for schools in Bronx, NY."
        />
        <meta
          property="og:title"
          content="Childcare Health & Environmental Consulting in Bronx NY"
        />
        <meta
          property="og:description"
          content="Contact WrightCo Academy for childcare facility health assessments and expert environmental health consulting services designed for schools in Bronx, NY."
        />
      </Helmet>

      <Layout className="cm-page contact-page">
        <section
          className="cm-hero"
          style={{
            backgroundImage: `url(${ImageUrl("contact-bnr.png")})`,
          }}
        >
          <div className="cm-hero-overlay" aria-hidden />
          <div className="cm-wrap cm-hero-inner">
            <div className="cm-hero-copy">
              <span className="cm-hero-badge">WE ARE LISTENING</span>
              <h1 className="fontFamily1 cm-hero-title">
                Get In Touch <span>With Us</span>
              </h1>
              <p className="fontFamily1 cm-hero-sub">
                We&apos;d love to hear from you. Let us know how we can support
                you and your organization.
              </p>
            </div>
          </div>
        </section>

        <div className="cm-wrap cm-main contact-main">
          <div className="contact-grid">
            <div className="contact-form-card">
              <form
                name="insightly_web_to_lead"
                action="https://crm.na1.insightly.com/WebToLead/Create"
                method="post"
                className="contactForm insightly-lead-form"
                acceptCharset="UTF-8"
                autoComplete="on"
              >
                <input type="hidden" name="formId" value="lwa1NcKfUM0Y1FzKDL3QZw==" />
                <input type="hidden" name="dekv" value="2" />

                <div className="insightly-row">
                  <div className="insightly-field">
                    <label
                      className="insightly-field-label"
                      htmlFor="insightly_firstName"
                    >
                      First Name <span className="insightly-required">*</span>
                    </label>
                    <input
                      id="insightly_firstName"
                      name="FirstName"
                      type="text"
                      className="insightly-input"
                      placeholder="First name"
                      required
                    />
                  </div>

                  <div className="insightly-field">
                    <label
                      className="insightly-field-label"
                      htmlFor="insightly_lastName"
                    >
                      Last Name <span className="insightly-required">*</span>
                    </label>
                    <input
                      id="insightly_lastName"
                      name="LastName"
                      type="text"
                      className="insightly-input"
                      placeholder="Last name"
                      required
                    />
                  </div>
                </div>

                <div className="insightly-field">
                  <label
                    className="insightly-field-label"
                    htmlFor="insightly_organization"
                  >
                    Organization
                  </label>
                  <input
                    id="insightly_organization"
                    name="OrganizationName"
                    type="text"
                    className="insightly-input"
                    placeholder="Organization"
                  />
                </div>

                <div className="insightly-row">
                  <div className="insightly-field">
                    <label
                      className="insightly-field-label"
                      htmlFor="insightly_Email"
                    >
                      Email <span className="insightly-required">*</span>
                    </label>
                    <input
                      id="insightly_Email"
                      name="email"
                      type="text"
                      className="insightly-input"
                      placeholder="Email"
                      required
                    />
                  </div>

                  <div className="insightly-field">
                    <label
                      className="insightly-field-label"
                      htmlFor="insightly_Phone"
                    >
                      Phone
                    </label>
                    <input
                      id="insightly_Phone"
                      name="phone"
                      type="text"
                      className="insightly-input"
                      placeholder="Phone"
                    />
                  </div>
                </div>

                <div className="insightly-field">
                  <label
                    className="insightly-field-label"
                    htmlFor="insightly_EmployeeCount"
                  >
                    Number of Employees
                  </label>
                  <input
                    id="insightly_EmployeeCount"
                    name="EmployeeCount"
                    type="text"
                    className="insightly-input"
                    placeholder="e.g. 25"
                  />
                </div>

                <div className="insightly-field">
                  <label
                    className="insightly-field-label"
                    htmlFor="insightly_Description"
                  >
                    Description
                  </label>
                  <textarea
                    id="insightly_Description"
                    name="Description"
                    className="insightly-textarea"
                    rows={5}
                    placeholder="How can we help?"
                  />
                </div>

                <input
                  type="hidden"
                  id="insightly_ResponsibleUser"
                  name="ResponsibleUser"
                  value="533219"
                />
                <input
                  type="hidden"
                  id="insightly_LeadSource"
                  name="LeadSource"
                  value="194411"
                />

                <div className="insightly-field insightly-field--submit">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="loginButton contact-submit-btn"
                  >
                    Send Message
                    <FaArrowRight className="contact-submit-arrow" aria-hidden />
                  </Button>
                </div>
              </form>
            </div>

            <aside className="contact-info-card">
              <h2 className="fontFamily1 contact-info-title">Get in touch</h2>
              <p className="fontFamily1 contact-info-subtitle">
                Let us know what you want to know. We want to help people learn,
                grow and achieve more in life.
              </p>

              <ul className="contact-info-list">
                <li className="contact-info-item">
                  <span className="contact-info-icon" aria-hidden>
                    <IoMdPin />
                  </span>
                  <div>
                    <p className="contact-info-label">Location</p>
                    <p className="contact-info-value">
                      1000 Front Street #147 Uniondale, NY 11553
                    </p>
                  </div>
                </li>
                <li className="contact-info-item">
                  <span className="contact-info-icon" aria-hidden>
                    <FaEnvelope />
                  </span>
                  <div>
                    <p className="contact-info-label">Email</p>
                    <p className="contact-info-value">info@support.com</p>
                  </div>
                </li>
                <li className="contact-info-item">
                  <span className="contact-info-icon" aria-hidden>
                    <BsFillTelephoneFill />
                  </span>
                  <div>
                    <p className="contact-info-label">Phone</p>
                    <p className="contact-info-value">+03601 885399</p>
                  </div>
                </li>
                <li className="contact-info-item">
                  <span className="contact-info-icon" aria-hidden>
                    <FaClock />
                  </span>
                  <div>
                    <p className="contact-info-label">Hours</p>
                    <p className="contact-info-value">
                      Mon - Fri: 9:00 AM - 6:00 PM
                      <br />
                      Saturday - Sunday: Closed
                    </p>
                  </div>
                </li>
              </ul>
            </aside>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default ContactUs;
